import _objectWithoutProperties from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/defineProperty";
import cx from 'classnames2';
import React from 'react';
import { Button } from '../Button';
import { Icon } from '../Icon';
import { Popover, PopoverContent, PopoverTrigger } from '../Popover';
import styles from './styles.scss';

var getPopoverContentStyle = function getPopoverContentStyle(variant) {
  var _cx;

  return cx((_cx = {}, _defineProperty(_cx, styles.narrow, variant === 'narrow'), _defineProperty(_cx, styles.default, variant === 'default'), _defineProperty(_cx, styles.wide, variant === 'wide'), _cx));
};

export var Dropdown = function Dropdown(_ref) {
  var buttonText = _ref.buttonText,
      _ref$buttonVariant = _ref.buttonVariant,
      buttonVariant = _ref$buttonVariant === void 0 ? 'neutral' : _ref$buttonVariant,
      _ref$buttonSize = _ref.buttonSize,
      buttonSize = _ref$buttonSize === void 0 ? 'default' : _ref$buttonSize,
      _ref$buttonDataTest = _ref.buttonDataTest,
      buttonDataTest = _ref$buttonDataTest === void 0 ? '' : _ref$buttonDataTest,
      _ref$buttonDisabled = _ref.buttonDisabled,
      buttonDisabled = _ref$buttonDisabled === void 0 ? false : _ref$buttonDisabled,
      _ref$buttonLoading = _ref.buttonLoading,
      buttonLoading = _ref$buttonLoading === void 0 ? false : _ref$buttonLoading,
      _ref$menuPlacement = _ref.menuPlacement,
      menuPlacement = _ref$menuPlacement === void 0 ? 'bottom-start' : _ref$menuPlacement,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'default' : _ref$variant,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["buttonText", "buttonVariant", "buttonSize", "buttonDataTest", "buttonDisabled", "buttonLoading", "menuPlacement", "variant", "children"]);

  return React.createElement(Popover, Object.assign({
    closeOnBlur: true,
    returnFocusOnClose: false,
    placement: menuPlacement
  }, rest), React.createElement(PopoverTrigger, null, React.createElement(Button, {
    variant: buttonVariant,
    size: buttonSize,
    dataTest: buttonDataTest,
    disabled: buttonDisabled,
    loading: buttonLoading
  }, buttonText, " ", React.createElement(Icon, {
    icon: "arrow-caret-down"
  }))), React.createElement(PopoverContent, {
    className: getPopoverContentStyle(variant)
  }, children));
};
Dropdown.displayName = 'Dropdown';